import { render, staticRenderFns } from "./OtherMsg.vue?vue&type=template&id=567910ea&scoped=true"
import script from "./OtherMsg.vue?vue&type=script&lang=js"
export * from "./OtherMsg.vue?vue&type=script&lang=js"
import style0 from "./OtherMsg.vue?vue&type=style&index=0&id=567910ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567910ea",
  null
  
)

export default component.exports